import {
  Alert,
  AlertTitle,
  Box,
  Button,
  CircularProgress,
  Divider,
  Paper,
  Stack,
  TextField,
  Typography,
  useMediaQuery,
  useTheme,
} from "@mui/material";
import MenuItemMui from "@mui/material/MenuItem";
import timezone from "dayjs/plugin/timezone";
import { useEffect, useState } from "react";
import Header from "../../components/Header";
import { Grid2 } from "@mui/material";
import { Apartment, SaveAlt, TextSnippet } from "@mui/icons-material";
import { tokens } from "../../theme";
import { DatePicker, LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { DemoContainer } from "@mui/x-date-pickers/internals/demo";
import NotificationToaste from "../global/NotificationToaste";
import dayjs, { utc } from "dayjs";
import axios from "axios";
import { DATA_SAVE_URL } from "../utils/UrlHandle";
import { setPostPayload, setPutPayload } from "../../services/api";
import ParticleSizeGravelFineDynamic from "./ParticleSizeGravelFineDynamic";

dayjs.extend(utc);
dayjs.extend(timezone);
dayjs.tz.setDefault("Asia/Colombo");

const ParticleSizeGravelFine = ({
  data,
  selectedTest,
  loggedUser,
  setOpenReportDialog,
}) => {
  const theme = useTheme();
  const colors = tokens(theme.palette.mode);
  const [authUsers, setAuthUsers] = useState([]);
  const isNonMobile = useMediaQuery("(min-width:600px)");
  const [open, setOpen] = useState(false);
  const [message, setMessage] = useState();
  const [messageType, setMessageType] = useState();
  const [loading, setLoading] = useState(true);
  const [update, setUpdate] = useState(false);
  const [eachTest, setEachTest] = useState({
    serialNo: "AUTO",
    dateOfCast: "",
    dateOfTest: "",
    weight: "",
    concreteMixtureArray: "",
    areaOfCube: "",
    compressiveStrength: "",
  });
  const [chartData, setChartData] = useState({
    sieve10: 10.0,
    sieve5: 5.0,
    sieve236: 2.36,
    sieve118: 1.18,
    sieve060: 0.6,
    sieve03: 0.3,
    sieve015: 0.15,
    sieve0: 0.0,

    weight10: 0.0,
    weight5: 0.0,
    weight236: 0.0,
    weight118: 0.0,
    weight060: 0.0,
    weight03: 0.0,
    weight015: 0.0,
    weight0: 0.0,

    retain10: 0.0,
    retain5: 0.0,
    retain236: 0.0,
    retain118: 0.0,
    retain060: 0.0,
    retain03: 0.0,
    retain015: 0.0,
    retain0: 0.0,

    cum10: 0.0,
    cum5: 0.0,
    cum236: 0.0,
    cum118: 0.0,
    cum060: 0.0,
    cum03: 0.0,
    cum015: 0.0,
    cum0: 0.0,

    passing10: 0.0,
    passing5: 0.0,
    passing236: 0.0,
    passing118: 0.0,
    passing060: 0.0,
    passing03: 0.0,
    passing015: 0.0,
    passing0: 0.0,

    spec10: "100.00%",
    spec5: "89 - 100%",
    spec236: "60 - 100%",
    spec118: "30 - 100%",
    spec060: "15 - 100%",
    spec03: "5 - 70%",
    spec015: "0 - 15%",
    spec0: "",

    spec10min: 100,
    spec5min: 89,
    spec236min: 60,
    spec118min: 30,
    spec060min: 15,
    spec03min: 5,
    spec015min: 0,
    spec0min: 0,

    spec10max: 100,
    spec5max: 100,
    spec236max: 100,
    spec118max: 100,
    spec060max: 100,
    spec03max: 70,
    spec015max: 15,
    spec0max: 0,

    spec10pass: false,
    spec5pass: false,
    spec236pass: false,
    spec118pass: false,
    spec060pass: false,
    spec03pass: false,
    spec015pass: false,
    spec0pass: false,
    totalValueOfWeight: 0.0,
  });
  const calculationOfChart = () => {
    const totalValueOfWeight =
      Number(chartData.weight10) +
      Number(chartData.weight5) +
      Number(chartData.weight236) +
      Number(chartData.weight118) +
      Number(chartData.weight060) +
      Number(chartData.weight03) +
      Number(chartData.weight015) +
      Number(chartData.weight0);

    console.log("total ", totalValueOfWeight);

    setChartData((pre) => ({
      ...pre,
      totalValueOfWeight,
      retain10: (pre.weight10 / totalValueOfWeight) * 100,
      retain5: (pre.weight5 / totalValueOfWeight) * 100,
      retain236: (pre.weight236 / totalValueOfWeight) * 100,
      retain118: (pre.weight118 / totalValueOfWeight) * 100,
      retain060: (pre.weight060 / totalValueOfWeight) * 100,
      retain03: (pre.weight03 / totalValueOfWeight) * 100,
      retain015: (pre.weight015 / totalValueOfWeight) * 100,
      retain0: (pre.weight0 / totalValueOfWeight) * 100,

      cum10: pre.retain10,
      cum5: Number(pre.cum10) + Number(pre.retain5),
    }));

    setChartData((pre) => ({
      ...pre,
      cum10: Number(pre.retain10),
      cum5: (Number(pre.retain10) + Number(pre.retain5)) / 100,
      cum236:
        (Number(pre.retain10) + Number(pre.retain5) + Number(pre.retain236)) /
        100,
      cum118:
        (Number(pre.retain10) +
          Number(pre.retain5) +
          Number(pre.retain236) +
          Number(pre.retain118)) /
        100,
      cum060:
        (Number(pre.retain10) +
          Number(pre.retain5) +
          Number(pre.retain236) +
          Number(pre.retain118) +
          Number(pre.retain060)) /
        100,
      cum03:
        (Number(pre.retain10) +
          Number(pre.retain5) +
          Number(pre.retain236) +
          Number(pre.retain118) +
          Number(pre.retain060) +
          Number(pre.retain03)) /
        100,
      cum015:
        (Number(pre.retain10) +
          Number(pre.retain5) +
          Number(pre.retain236) +
          Number(pre.retain118) +
          Number(pre.retain060) +
          Number(pre.retain03) +
          Number(pre.retain015)) /
        100,
      cum0:
        (Number(pre.retain10) +
          Number(pre.retain5) +
          Number(pre.retain236) +
          Number(pre.retain118) +
          Number(pre.retain060) +
          Number(pre.retain03) +
          Number(pre.retain015) +
          Number(pre.retain0)) /
        100,
    }));

    setChartData((pre) => ({
      ...pre,
      passing10: Number(100),
      passing5: Number(100) - Number(pre.retain5),
      passing236: Number(100) - Number(pre.retain5) - Number(pre.retain236),
      passing118:
        Number(100) -
        Number(pre.retain5) -
        Number(pre.retain236) -
        Number(pre.retain118),
      passing060:
        Number(100) -
        Number(pre.retain5) -
        Number(pre.retain236) -
        Number(pre.retain118) -
        Number(pre.retain060),
      passing03:
        Number(100) -
        Number(pre.retain5) -
        Number(pre.retain236) -
        Number(pre.retain118) -
        Number(pre.retain060) -
        Number(pre.retain03),
      passing015:
        Number(100) -
        Number(pre.retain5) -
        Number(pre.retain236) -
        Number(pre.retain118) -
        Number(pre.retain060) -
        Number(pre.retain03) -
        Number(pre.retain015),
      passing0:
        Number(100) -
        Number(pre.retain5) -
        Number(pre.retain236) -
        Number(pre.retain118) -
        Number(pre.retain060) -
        Number(pre.retain03) -
        Number(pre.retain015) -
        Number(pre.retain0),
    }));

    setChartData((pre) => ({
      ...pre,
      passing0: pre.passing0 < 0 ? 0 : pre.passing0,
    }));

    setChartData((pre) => ({
      ...pre,
      spec10pass:
        Number(pre.passing10) >= Number(pre.spec10min) &&
        Number(pre.passing10) <= Number(pre.spec10max)
          ? true
          : false,
      spec5pass:
        Number(pre.passing5) >= Number(pre.spec5min) &&
        Number(pre.passing5) <= Number(pre.spec5max)
          ? true
          : false,
      spec236pass:
        Number(pre.passing236) >= Number(pre.spec236min) &&
        Number(pre.passing236) <= Number(pre.spec236max)
          ? true
          : false,
      spec118pass:
        Number(pre.passing118) >= Number(pre.spec118min) &&
        Number(pre.passing118) <= Number(pre.spec118max)
          ? true
          : false,
      spec060pass:
        Number(pre.passing060) >= Number(pre.spec060min) &&
        Number(pre.passing060) <= Number(pre.spec060max)
          ? true
          : false,
      spec03pass:
        Number(pre.passing03) >= Number(pre.spec03min) &&
        Number(pre.passing03) <= Number(pre.spec03max)
          ? true
          : false,
      spec015pass:
        Number(pre.passing015) >= Number(pre.spec015min) &&
        Number(pre.passing015) <= Number(pre.spec015max)
          ? true
          : false,
    }));

    console.log("total ", chartData);
  };

  const [mainData, setMainData] = useState({
    date: dayjs(new Date()).format("YYYY-MM-DD"),
    institute: data.institute,
    reference: "",
    sampleLocation: "",
    cement: "",
    grade: "",
    concreteMixture: "",
    areaOfCube: "5000",
    dateOfCast: dayjs(new Date()).format("YYYY-MM-DD"),
    dateOfTest: dayjs(new Date()).format("YYYY-MM-DD"),
    testDays: "",
    labTestsDataFromSubs: [],
    specialNote:
      "The test results reported herein relate to the specimens submitted to material testing laboratory & we do not certify the quality of a product / site in general.",
    remarks: "",
    reportType: "AGRI",
    sampleTakenBy: "",
    testedBy: { id: "" },
    reportedBy: loggedUser,
    authorizedBy: null,
    labRequest: data,
    barcode: "",
    labRequestTests: selectedTest,
    referenceReportNumber: "",
    rejectReason: "",
  });

  const concreteMixtureArray = [{ id: 1, label: "Sand", value: "Sand" }];

  const handleCloseToaste = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }
    setOpen(false);
  };

  useEffect(() => {
    loadBasicData();
    // setTimeout(() => {
    //   calculationOfChart();
    // }, 5000);
    return () => loadBasicData();
  }, []);

  const loadBasicData = async () => {
    // console.log("selectedid ", selectedTest.id);
    setLoading(true);

    await axios
      .get(DATA_SAVE_URL + "/api/v1/dataForm/reportData/" + data.id, {
        params: {
          testId: selectedTest.id,
        },
        headers: {
          Authorization: `Bearer ${localStorage.getItem("token")}`,
        },
      })
      .then(function (response) {
        // console.log("tada", response.data);
        if (response.data.labTestFormData !== null) {
          setUpdate(true);
          setMainData(response.data.labTestFormData);
          console.log("asss", response.data);
          const chartTableData =
            response.data.labTestFormData.labTestsDataFromSubs;
          console.log("data ,", chartTableData);

          console.log("read data", mainData);

          const totalValueOfWeight =
            Number(chartData.weight10) +
            Number(chartData.weight5) +
            Number(chartData.weight236) +
            Number(chartData.weight118) +
            Number(chartData.weight060) +
            Number(chartData.weight03) +
            Number(chartData.weight015) +
            Number(chartData.weight0);

          setChartData((pre) => ({
            ...pre,
            weight10: chartTableData[0]?.weightRetained.toFixed(3),
            retain10: chartTableData[0]?.retained,
            cum10: chartTableData[0]?.cum,
            passing10: chartTableData[0]?.passing,

            weight5: chartTableData[1]?.weightRetained,
            retain5: chartTableData[1]?.retained,
            cum5: chartTableData[1]?.cum,
            passing5: chartTableData[1]?.passing,

            weight236: chartTableData[2]?.weightRetained.toFixed(3),
            retain236: chartTableData[2]?.retained,
            cum236: chartTableData[2]?.cum,
            passing236: chartTableData[2]?.passing,

            weight118: chartTableData[3]?.weightRetained.toFixed(3),
            retain118: chartTableData[3]?.retained,
            cum118: chartTableData[3]?.cum,
            passing118: chartTableData[3]?.passing,

            weight060: chartTableData[4]?.weightRetained.toFixed(3),
            retain060: chartTableData[4]?.retained,
            cum060: chartTableData[4]?.cum,
            passing060: chartTableData[4]?.passing,

            weight03: chartTableData[5]?.weightRetained.toFixed(3),
            retain03: chartTableData[5]?.retained,
            cum03: chartTableData[5]?.cum,
            passing03: chartTableData[5]?.passing,

            weight015: chartTableData[6]?.weightRetained.toFixed(3),
            retain015: chartTableData[6]?.retained,
            cum015: chartTableData[6]?.cum,
            passing015: chartTableData[6]?.passing,

            weight0: chartTableData[7]?.weightRetained.toFixed(3),
            retain0: chartTableData[7]?.retained,
            cum0: chartTableData[7]?.cum,
            passing0: chartTableData[7]?.passing,

            totalValueOfWeight:
              Number(chartTableData[0]?.weightRetained) +
              Number(chartTableData[1]?.weightRetained) +
              Number(chartTableData[2]?.weightRetained) +
              Number(chartTableData[3]?.weightRetained) +
              Number(chartTableData[4]?.weightRetained) +
              Number(chartTableData[5]?.weightRetained) +
              Number(chartTableData[6]?.weightRetained) +
              Number(chartTableData[7]?.weightRetained),

            spec10pass:
              Number(chartTableData[0]?.passing) >= Number(pre.spec10min) &&
              Number(chartTableData[0]?.passing) <= Number(pre.spec10max)
                ? true
                : false,
            spec5pass:
              Number(chartTableData[1]?.passing) >= Number(pre.spec5min) &&
              Number(chartTableData[1]?.passing) <= Number(pre.spec5max)
                ? true
                : false,
            spec236pass:
              Number(chartTableData[2]?.passing) >= Number(pre.spec236min) &&
              Number(chartTableData[2]?.passing) <= Number(pre.spec236max)
                ? true
                : false,
            spec118pass:
              Number(chartTableData[3]?.passing) >= Number(pre.spec118min) &&
              Number(chartTableData[3]?.passing) <= Number(pre.spec118max)
                ? true
                : false,
            spec060pass:
              Number(chartTableData[4]?.passing) >= Number(pre.spec060min) &&
              Number(chartTableData[4]?.passing) <= Number(pre.spec060max)
                ? true
                : false,
            spec03pass:
              Number(chartTableData[5]?.passing) >= Number(pre.spec03min) &&
              Number(chartTableData[5]?.passing) <= Number(pre.spec03max)
                ? true
                : false,
            spec015pass:
              Number(chartTableData[6]?.passing) >= Number(pre.spec015min) &&
              Number(chartTableData[6]?.passing) <= Number(pre.spec015max)
                ? true
                : false,
          }));
        } else {
          addCubesToTable();
        }

        setAuthUsers(response.data.authUsers);
      })
      .catch(function (error) {
        console.log(error);
        setMessage(error);
        setMessageType("error");
        setOpen(true);
      });
    setLoading(false);
  };

  const addCubesToTable = () => {
    console.log("data qty " + selectedTest.quantity);
    const newItems = Array.from({ length: selectedTest.quantity }, (_, i) => ({
      serialNo: selectedTest.startingSerialNo + i,
      dateOfCast: dayjs(mainData.dateOfCast).format("YYYY-MM-DD"),
      dateOfTest: dayjs(mainData.dateOfTest).format("YYYY-MM-DD"),
      areaOfCube: mainData.areaOfCube,
      weight: "",
      compressiveStrength: "",
      concreteMixture: mainData.concreteMixture,
    }));
    setMainData((pre) => ({
      ...pre,
      labTestsDataFromSubs: newItems,
    }));
  };

  const addTestHandle = () => {
    // console.log("added test data ", eachTest);

    const updatedTest = {
      ...eachTest, // or pre if it's based on previous state
      dateOfCast: dayjs(mainData.dateOfCast).format("YYYY-MM-DD"),
      dateOfTest: dayjs(mainData.dateOfTest).format("YYYY-MM-DD"),
      areaOfCube: "22500",
      concreteMixture: mainData.concreteMixture,
    };

    setMainData((pre) => ({
      ...pre,
      labTestsDataFromSubs: [...pre.labTestsDataFromSubs, updatedTest],
    }));
  };

  const rearrangeChartArray = () => {
    const sieveArray = [];

    sieveArray.push(
      {
        sieveSize: Number(chartData.sieve10).toFixed(3),
        weightRetained: Number(chartData.weight10).toFixed(3),
        retained: Number(chartData.retain10).toFixed(3),
        cum: Number(chartData.cum10).toFixed(3),
        passing: Number(chartData.passing10).toFixed(3),
        color: chartData.spec10,
        description: chartData.spec10pass ? "SATISFACTORY" : "NOT-SATISFACTORY",
      },
      {
        sieveSize: Number(chartData.sieve5).toFixed(3),
        weightRetained: Number(chartData.weight5).toFixed(3),
        retained: Number(chartData.retain5).toFixed(3),
        cum: Number(chartData.cum5).toFixed(3),
        passing: Number(chartData.passing5).toFixed(3),
        color: chartData.spec5,
        description: chartData.spec5pass ? "SATISFACTORY" : "NOT-SATISFACTORY",
      },
      {
        sieveSize: Number(chartData.sieve236).toFixed(3),
        weightRetained: Number(chartData.weight236).toFixed(3),
        retained: Number(chartData.retain236).toFixed(3),
        cum: Number(chartData.cum236).toFixed(3),
        passing: Number(chartData.passing236).toFixed(3),
        color: chartData.spec236,
        description: chartData.spec236pass
          ? "SATISFACTORY"
          : "NOT-SATISFACTORY",
      },
      {
        sieveSize: Number(chartData.sieve118).toFixed(3),
        weightRetained: Number(chartData.weight118).toFixed(3),
        retained: Number(chartData.retain118).toFixed(3),
        cum: Number(chartData.cum118).toFixed(3),
        passing: Number(chartData.passing118).toFixed(3),
        color: chartData.spec118,
        description: chartData.spec118pass
          ? "SATISFACTORY"
          : "NOT-SATISFACTORY",
      },
      {
        sieveSize: Number(chartData.sieve060).toFixed(3),
        weightRetained: Number(chartData.weight060).toFixed(3),
        retained: Number(chartData.retain060).toFixed(3),
        cum: Number(chartData.cum060).toFixed(3),
        passing: Number(chartData.passing060).toFixed(3),
        color: chartData.spec060,
        description: chartData.spec060pass
          ? "SATISFACTORY"
          : "NOT-SATISFACTORY",
      },
      {
        sieveSize: Number(chartData.sieve03).toFixed(3),
        weightRetained: Number(chartData.weight03).toFixed(3),
        retained: Number(chartData.retain03).toFixed(3),
        cum: Number(chartData.cum03).toFixed(3),
        passing: Number(chartData.passing03).toFixed(3),
        color: chartData.spec03,
        description: chartData.spec03pass ? "SATISFACTORY" : "NOT-SATISFACTORY",
      },
      {
        sieveSize: Number(chartData.sieve015).toFixed(3),
        weightRetained: Number(chartData.weight015).toFixed(3),
        retained: Number(chartData.retain015).toFixed(3),
        cum: Number(chartData.cum015).toFixed(3),
        passing: Number(chartData.passing015).toFixed(3),
        color: chartData.spec015,
        description: chartData.spec015pass
          ? "SATISFACTORY"
          : "NOT-SATISFACTORY",
      },
      {
        sieveSize: Number(chartData.sieve0).toFixed(3),
        weightRetained: Number(chartData.weight0).toFixed(3),
        retained: Number(chartData.retain0).toFixed(3),
        cum: Number(chartData.cum0).toFixed(3),
        passing: Number(chartData.passing0).toFixed(3),
        color: chartData.spec0,
        description: chartData.spec0pass ? "SATISFACTORY" : "NOT-SATISFACTORY",
      },
    );
    return sieveArray;
  };

  const handleSaveData = async () => {
    if (mainData.testedBy.id === "") {
      setMessage("Select tested by user..!");
      setMessageType("warning");
      setOpen(true);
      return;
    }

    if (!update) {
      setLoading(true);

      //Add sieve data details to main objec array

      const sendObject = {
        date: mainData.date,
        institute: { id: mainData.institute.id },
        reference: mainData.reference,
        sampleLocation: mainData.sampleLocation,
        cement: mainData.cement,
        grade: mainData.grade,
        concreteMixture: mainData.concreteMixture,
        areaOfCube: mainData.areaOfCube,
        dateOfCast: mainData.dateOfCast,
        dateOfTest: mainData.dateOfTest,
        testDays: mainData.testDays,
        labTestsDataFromSubs: rearrangeChartArray(),
        specialNote: mainData.specialNote,
        remarks: mainData.remarks,
        reportType: "AGRI",
        sampleTakenBy: mainData.sampleTakenBy,
        testedBy: { id: mainData.testedBy.id },
        reportedBy: { id: mainData.reportedBy.id },
        authorizedBy: null,
        labRequest: { id: mainData.labRequest.id },
        barcode: "",
        labRequestTests: { id: mainData.labRequestTests.id },
        referenceReportNumber: mainData.referenceReportNumber,
      };
      console.log("main data save sendObject ", sendObject);
      await setPostPayload
        .setPayloadData("/dataForm/saveReport", sendObject)

        .then(function (response) {
          console.log(response);
          setMessage("Data saved successfully..!");
          setMessageType("success");
          setOpen(true);
          // handleClose();
          // resetMainData();
          // reloadTableData();
          setLoading(false);
          setOpenReportDialog(false);
        })
        .catch(function (error) {
          console.log(error);
          setMessage(error);
          setMessageType("error");
          setOpen(true);
          setLoading(false);
        });
    } else {
      setLoading(true);
      // console.log("main data ", mainData);
      setMainData((pre) => ({
        ...pre,
        id: mainData.id,
      }));

      console.log("***asss*********", mainData);

      const sendObject = {
        id: mainData.id,
        date: mainData.date,
        institute: { id: mainData.institute.id },
        reference: mainData.reference,
        sampleLocation: mainData.sampleLocation,
        cement: mainData.cement,
        grade: mainData.grade,
        concreteMixture: mainData.concreteMixture,
        areaOfCube: mainData.areaOfCube,
        dateOfCast: mainData.dateOfCast,
        dateOfTest: mainData.dateOfTest,
        testDays: mainData.testDays,
        labTestsDataFromSubs: rearrangeChartArray(),
        specialNote: mainData.specialNote,
        remarks: mainData.remarks,
        reportType: "AGRI",
        sampleTakenBy: mainData.sampleTakenBy,
        testedBy: { id: mainData.testedBy.id },
        reportedBy: { id: mainData.reportedBy.id },
        authorizedBy: null,
        labRequest: { id: mainData.labRequest.id },
        barcode: mainData.barcode,
        labRequestTests: { id: mainData.labRequestTests.id },
        referenceReportNumber: mainData.referenceReportNumber,
      };

      console.log("************", sendObject);

      await setPutPayload
        .setPayloadData("/dataForm/updateReport", sendObject)
        .then(function (response) {
          // console.log(response);
          setMessage("Data saved successfully..!");
          setMessageType("success");
          setOpen(true);
          // resetMainData();
          // reloadTableData();
          setLoading(false);
          setOpenReportDialog(false);
        })
        .catch(function (error) {
          console.log(error);
          setMessage(error);
          setMessageType("error");
          setOpen(true);
          setLoading(false);
        });
    }
  };

  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        padding: "0 0 0 0",
        margin: "0 0 0 0",
      }}
    >
      {mainData.rejectReason === null || mainData.rejectReason === "" ? (
        ""
      ) : (
        <Stack sx={{ width: "100%", marginBottom: "5px" }}>
          <Alert severity="error" width="100%">
            <AlertTitle>This report is rejected.</AlertTitle>
            Reason : {mainData?.rejectReason}
          </Alert>
        </Stack>
      )}

      <Paper
        sx={{
          padding: "10px",
          borderRadius: "8px",
          marginBottom: "20px",
        }}
        elevation={3}
      >
        <Header title="SIEVE ANALYSIS TEST REPORT." subtitle="GENERAL DATA" />
        <Box>
          <Grid2 container spacing={1}>
            <Grid2 size={8}>
              <Paper elevation={2} sx={{ padding: "10px" }}>
                <Grid2 container spacing={2}>
                  <Grid2 size={3}>
                    <Box display="flex" alignItems="center" columnGap="10px">
                      <TextSnippet />
                      <Typography variant="h5">PROJECT</Typography>
                    </Box>
                  </Grid2>
                  <Grid2 size={9}>
                    <Typography variant="h5" component="h2">
                      {data.project}
                    </Typography>
                  </Grid2>
                  <Grid2 size={3}>
                    <Box display="flex" alignItems="center" columnGap="10px">
                      <Apartment />
                      <Typography variant="h5" component="h2">
                        INSTITUTE NAME
                      </Typography>
                    </Box>
                  </Grid2>
                  <Grid2 size={9}>
                    <Typography variant="h5" component="h2">
                      {data.institute.instituteName}
                    </Typography>
                  </Grid2>
                  <Grid2 size={12}>
                    <TextField
                      fullWidth
                      variant="outlined"
                      size="small"
                      type="text"
                      label="Reference"
                      value={mainData.reference}
                      onChange={(e) =>
                        setMainData((pre) => ({
                          ...pre,
                          reference: e.target.value,
                        }))
                      }
                      sx={{ gridColumn: "span 2" }}
                    />
                  </Grid2>
                  <Grid2 size={12} justifyContent="center">
                    <TextField
                      fullWidth
                      variant="outlined"
                      size="small"
                      type="text"
                      label="Sample Locations"
                      value={mainData.sampleLocation}
                      onChange={(e) =>
                        setMainData((pre) => ({
                          ...pre,
                          sampleLocation: e.target.value,
                        }))
                      }
                      sx={{ gridColumn: "span 2" }}
                    />
                  </Grid2>
                  <Grid2 size={12} justifyContent="center">
                    <TextField
                      fullWidth
                      variant="outlined"
                      size="small"
                      type="text"
                      label="Report Reference Number"
                      value={mainData.referenceReportNumber}
                      onChange={(e) =>
                        setMainData((pre) => ({
                          ...pre,
                          referenceReportNumber: e.target.value,
                        }))
                      }
                      sx={{ gridColumn: "span 2" }}
                    />
                  </Grid2>
                </Grid2>
              </Paper>
            </Grid2>
            <Grid2 size={4}>
              <Paper elevation={2} sx={{ padding: "10px", height: "100%" }}>
                <Grid2 container>
                  <Grid2 size={12} textAlign="center">
                    <Typography variant="h5">REPORT NUMBER</Typography>
                  </Grid2>
                  <Grid2 size={12} textAlign="center">
                    <Typography color={colors.redAccent[500]} variant="h5">
                      {update
                        ? "QC/" +
                          mainData.reportType +
                          "/" +
                          mainData.labRequest.year +
                          "/" +
                          String(mainData.id).padStart(4, "0")
                        : "AUTO"}
                    </Typography>
                  </Grid2>
                  <Grid2 size={12} textAlign="center">
                    <Typography variant="h5">JOB NO</Typography>
                  </Grid2>
                  <Grid2 size={12} textAlign="center">
                    <Typography color={colors.redAccent[500]} variant="h5">
                      {data.year + "/" + String(data.id).padStart(4, "0")}
                    </Typography>
                  </Grid2>
                  <Grid2 size={12} textAlign="center">
                    <Typography variant="h5">REPORT DATE</Typography>
                  </Grid2>
                  <Grid2 size={12} textAlign="center" justifyItems="center">
                    <Box sx={{ width: "200px" }}>
                      <LocalizationProvider dateAdapter={AdapterDayjs}>
                        <DemoContainer
                          components={["DatePicker"]}
                          sx={{ paddingTop: "8px" }}
                        >
                          <DatePicker
                            label="Date of report"
                            size="small"
                            format="YYYY-MM-DD"
                            timezone="Asia/Colombo"
                            value={
                              mainData.date
                                ? dayjs(mainData.date).tz("Asia/Colombo", true)
                                : dayjs(new Date()).tz("Asia/Colombo", true)
                            }
                            onChange={(newValue) => {
                              const colomboTime = newValue?.tz(
                                "Asia/Colombo",
                                true,
                              );
                              setMainData((pre) => ({
                                ...pre,
                                date: dayjs(colomboTime).format("YYYY-MM-DD"),
                              }));
                            }}
                            slotProps={{
                              textField: {
                                variant: "outlined",
                                size: "small",
                              },
                            }}
                          />
                        </DemoContainer>
                      </LocalizationProvider>
                    </Box>
                  </Grid2>
                </Grid2>
              </Paper>
            </Grid2>
          </Grid2>
        </Box>
      </Paper>
      <Paper
        sx={{ borderRadius: "8px", padding: "10px", width: "100%" }}
        elevation={3}
      >
        <Header title="FINE AGGREGATE" subtitle="ENTER TESTING DATA" />
        <Divider sx={{ margin: "10px 0px 10px 0" }} />
        <ParticleSizeGravelFineDynamic
          addTestHandle={addTestHandle}
          eachTest={eachTest}
          mainData={mainData}
          setMainData={setMainData}
          isNonMobile={isNonMobile}
          concreteMixtureArray={concreteMixtureArray}
          chartData={chartData}
          setChartData={setChartData}
          calculationOfChart={calculationOfChart}
        />
      </Paper>
      {loading ? (
        <CircularProgress
          sx={{
            color: colors.greenAccent[500],
            position: "absolute",
            zIndex: 10,
          }}
        />
      ) : (
        ""
      )}
      <Paper
        sx={{
          width: "100%",
          padding: "10px",
          borderRadius: "8px",
          marginTop: "20px",
          marginBottom: "20px",
        }}
        elevation={3}
      >
        <Header title="TEST NOTES" subtitle="AUTHORIZE DATA" />
        <Grid2 container spacing={1} marginTop="10px">
          <Grid2 size={12}>
            <TextField
              variant="outlined"
              type="text"
              size="small"
              fullWidth
              label="Special Notes"
              value={mainData.specialNote}
              onChange={(e) =>
                setMainData((pre) => ({
                  ...pre,
                  specialNote: e.target.value,
                }))
              }
            />
          </Grid2>
          <Grid2 size={6}>
            <TextField
              variant="outlined"
              type="text"
              size="small"
              fullWidth
              label="Remarks"
              value={mainData.remarks}
              onChange={(e) =>
                setMainData((pre) => ({
                  ...pre,
                  remarks: e.target.value,
                }))
              }
            />
          </Grid2>
          <Grid2 size={4}>
            <TextField
              variant="outlined"
              type="text"
              size="small"
              fullWidth
              label="Sample taken / supplied by"
              value={mainData.sampleTakenBy}
              onChange={(e) =>
                setMainData((pre) => ({
                  ...pre,
                  sampleTakenBy: e.target.value,
                }))
              }
            />
          </Grid2>
          <Grid2 size={2}>
            <TextField
              select
              label="Tested by"
              fullWidth
              size="small"
              defaultValue=""
              value={mainData.testedBy.id}
              onChange={(e) => {
                e.preventDefault();
                setMainData((pre) => ({
                  ...pre,
                  testedBy: {
                    ...pre.testedBy,
                    id: e.target.value,
                  },
                }));
              }}
            >
              {authUsers.map((data) => (
                <MenuItemMui key={data.id} value={data.id}>
                  {data.firstName + " " + data.lastName}
                </MenuItemMui>
              ))}
            </TextField>
          </Grid2>

          <Grid2 size={12} display="flex" justifyContent="flex-end">
            <Divider sx={{ width: "100%" }} />
          </Grid2>

          <Grid2 size={12} display="flex" justifyContent="flex-end">
            <Button
              type="submit"
              color="secondary"
              loading={loading}
              startIcon={<SaveAlt />}
              variant="contained"
              onClick={handleSaveData}
            >
              Save Data
            </Button>
          </Grid2>
        </Grid2>
      </Paper>
      <NotificationToaste
        handleCloseToaste={handleCloseToaste}
        open={open}
        message={message}
        messageType={messageType}
      />
    </Box>
  );
};

export default ParticleSizeGravelFine;
